import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import { FilterWrapper } from '../../style'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import { useParams } from 'react-router-dom'
import i18n from '~/components/i18n'
import { Dropdown } from 'semantic-ui-react'
import TableComponent from '~/components/TableComponent'
import { useAuth } from '~/routes/components/AuthProvider'
import { LIGHT_USER_ROLE_SLUG } from '~/Constants'
import DeleteBooking from './DeleteBooking'

const getTableColumnHeaders = () => [
  {
    name: i18n.t('Booking date'),
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
    key: 'bookingDate'
  },
  {
    name: i18n.t('Article No.'),
    key: 'uniqueId'
  },
  {
    name: i18n.t('Article name'),
    key: 'name'
  },
  {
    name: i18n.t('Unit'),
    key: 'unitLabel'
  },
  {
    name: i18n.t('Sum'),
    key: 'amount',
    type: 'no-unit-number',
    decimalScale: 0
  },
  {
    name: i18n.t('Article price'),
    key: 'netPrice',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Tax'),
    key: 'tax',
    type: 'tax-number'
  },
  {
    name: i18n.t('Article price bruto (in €)'),
    key: 'grossPrice',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Actions')
  }
]

const BookingHistory: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { systemData: { logged: { roleSlug } } } = useAuth()
  const actions = [
    {
      popupMessage: i18n.t('Delete'),
      type: 'icon',
      name: 'trash',
      size: 'large',
      actionType: 'delete',
      verifiedAction: 1,
      verifiedActionKey: 'deleteAvailable'
    }
  ]

  const [deleteBooking, setDeleteBooking] = useState(null)
  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0,
    articleId: '',
    month: ''
  })

  const {
    data: bookingSettings,
    isLoading: isBusySettings,
    refetch: fetchSettings
  } = FarmersQuery.bookingHistorySettings(id)

  const {
    data: bookingData,
    isLoading: isBusy,
    refetch: fetchFilteredData,
    isFetching: isFetching
  } = FarmersQuery.bookingHistoryList(id, {
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  }, dataFiltered.month !== '')

  useEffect(() => {
    fetchSettings()
    fetchFilteredData()
  }, [t])

  useEffect(() => {
    fetchFilteredData()
  }, [dataFiltered])

  useEffect(() => {
    if (bookingSettings && !dataFiltered.month) {
      setDataFiltered({
        ...dataFiltered,
        month: bookingSettings?.months[0]?.key
      })
    }
  }, [bookingSettings])

  function renderFilters() {
    return <FilterWrapper>
      <Dropdown
        selection
        placeholder={t('Select month')}
        selectOnBlur={false}
        value={dataFiltered.month}
        onChange={(e, data) => setDataFiltered({ ...dataFiltered, month: data.value as string })}
        options={bookingSettings?.months?.map(month => ({ value: month.key, text: month.label })) || []}
      />
      <Dropdown
        selection
        placeholder={t('Article ID')}
        clearable
        selectOnBlur={false}
        value={dataFiltered.articleId}
        onChange={(e, data) => setDataFiltered({ ...dataFiltered, articleId: data.value as string })}
        options={bookingSettings?.articles?.map(article => ({ value: article.id, text: article.name })) || []}
      />
    </FilterWrapper>
  }

  function handleActionClick(row, type) {
    switch (type) {
      case 'delete':
        return setDeleteBooking(row)
    }
  }

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={getTableColumnHeaders()}
      dataFiltered={dataFiltered}
      handleClickAction={(row, type) => handleActionClick(row, type)}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      actions={roleSlug === LIGHT_USER_ROLE_SLUG ? [] : actions}
      animated
      upward={false}
      isFetchingData={isFetching}
      total={filtered}
    />
  }

  function renderDeleteBooking() {
    return <DeleteBooking
      booking={deleteBooking}
      handleClose={(submited) => {
        setDeleteBooking(null)
        if (submited) {
          fetchFilteredData()
        }
      }}
    />
  }

  const { filtered, rows } = bookingData ? bookingData : { filtered: 0, rows: [] };

  return <Layout
    title={t('Booking history')}
    childContainerSize={'300px'}
    filters={renderFilters()}
    isBusy={isBusy || isBusySettings}
    useSpinner
  >
    {renderDeleteBooking()}
    {renderTable()}
  </Layout>
}
export default BookingHistory